"use client";

import { useRef, useEffect } from "react";
import { useStore } from "react-redux";
import { RootState } from "@/store/store";
import { useAppDispatch } from "@/hooks/hooks";
import { setBanners, setSettings, setHomeDetails } from "@/slices/homeSlice";
import { setBlogList, setFAQList } from "@/slices/aboutUsSlice";
import { getHomeDetails } from "@/services/home.services";

interface StoreInitializerProps {
  settings?: any[];
  banners?: any[];
  blogs?: any[];
  faqs?: any[];
  homeDetails?: any;
}

export default function StoreInitializer({ settings, banners, blogs, faqs, homeDetails }: StoreInitializerProps) {
  const dispatch = useAppDispatch();
  const store = useStore<RootState>();
  const initialized = useRef(false);
  const clientHasDispatched = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      const state = store.getState();
      const hasSettings = state.home.SettingList && state.home.SettingList.length > 0;
      const hasBanners = state.home.BannerList && state.home.BannerList.length > 0;
      const hasBlogs = state.aboutUs.BlogList && state.aboutUs.BlogList.length > 0;
      const hasFaqs = state.aboutUs.FAQList && state.aboutUs.FAQList.length > 0;
      const hasHomeDetails = state.home.homeDetails && Object.keys(state.home.homeDetails).length > 0;

      if (settings && !hasSettings) {
        dispatch(setSettings(settings));
      }
      if (banners && !hasBanners) {
        dispatch(setBanners(banners));
      }
      if (blogs && !hasBlogs) {
        dispatch(setBlogList(blogs));
      }
      if (faqs && !hasFaqs) {
        dispatch(setFAQList(faqs));
      }
      if (homeDetails && !hasHomeDetails) {
        dispatch(setHomeDetails(homeDetails));
      }
      initialized.current = true;
    }
  }, [dispatch, store, settings, banners, blogs, faqs, homeDetails]);

  useEffect(() => {
    if (clientHasDispatched.current) return;

    const state = store.getState();
    const hasHomeDetails = state.home.homeDetails && Object.keys(state.home.homeDetails).length > 0;
    const hasNoHomeData = !homeDetails || Object.keys(homeDetails).length === 0;

    if (hasNoHomeData && !hasHomeDetails) {
      clientHasDispatched.current = true;
      dispatch(getHomeDetails());
    }
  }, [dispatch, store, homeDetails]);

  return null;
}


